import React from 'react';
import './index.scss';
import { FaCheck, FaQuestion } from 'react-icons/fa';
// import { Products }  from '../../utils/Products'
import parse from 'react-html-parser';
import { Link } from 'react-router-dom';
import { Event } from '../Tracking';

export default function ProductsTable({
	benefits,
	benefitsTable,
	plansYalo,
	loja,
	benefitsTips,
	planPrice
}) {
	//props: produtos: (lista) {lista de beneficios (descrição mini e descrição full), nome (string) e botao de cadastrar (button)}
	const btnStyle = {
		'YALO Vida': {
			background: '#E7E70D',
			border: '1px solid #E7E70D',
			color: '#16477D'
		},
		'YALO Fidelidade': { background: '#0079B3', border: '1px solid #0079B3' },
		'YALO Saude': {
			background: '#e3672d',
			border: '1px solid #e3672d'
		},
		'YALO e-MED': {
			background: '#e3672d',
			border: '1px solid #e3672d'
		},
		'YALO Individual': {
			background: '#e3672d',
			border: '1px solid #e3672d'
		}
	};

	const titleStyle = {
		'YALO Fidelidade': 'fidelidade',
		'YALO Saude': 'saude',
		'YALO Vida': 'vida',
		'YALO e-MED': 'telemedicina',
		'YALO Individual': 'individual'
	};

	// const planPrice = {
	// 	'YALO Fidelidade': '31,00',
	// 	'YALO Vida': '31,00',
	// 	'YALO Saude': '53,20'
	// };

	var size = Object.keys(plansYalo).length;
	const colCount =
		size === 1 ? 'unique-col' : size === 2 ? 'double-col' : 'col-grid';

	return (
		<section className='section-table'>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col-12'>
						<h2 style={{ color: '#0079b3', padding: '0 5px' }}>
							{loja === 'fretebras' ||
							loja === 'brasiladmindividual' ||
							loja === 'emed' ||
							loja === 'brasiladmvida' ||
							loja === 'brasiladmfidelidade' ? (
								<strong>Conheça nossa assinatura</strong>
							) : (
								<strong>Conheça nossas assinaturas</strong>
							)}
						</h2>
						<div className={`set-table ${colCount}`}>
							<table className='table-wrapper'>
								<tbody>
									<tr className={loja}>
										<th className='noneOnMobile'></th>
										{Object.keys(plansYalo).map(key => {
											let thStyle = titleStyle[key];
											let title = key == 'saude' ? key.replace('u', 'ú') : key;
											//  = key.replace('u', 'ú');

											return (
												<th className={`table-${thStyle} ${loja}`} key={key}>
													{title}
												</th>
											);
										})}
									</tr>
									{benefitsTable.map((benefitId, index) => {
										let difClass = index % 2 !== 0 ? 'dif' : '';
										return (
											<tr
												className={`${difClass} tr-border ${loja}`}
												key={benefitId}>
												<td className={'row-table td'}>
													{' '}
													{parse(benefits[benefitId])}
													{benefitsTips[benefitId] !== '' ? (
														<button
															type='button'
															className='btn btn-secondary'
															data-toggle='tooltip'
															data-html='true'
															data-placement='top'
															title={benefitsTips[benefitId]}>
															<FaQuestion size={8} color={'#FFF'} />
														</button>
													) : (
														''
													)}
												</td>
												{Object.keys(plansYalo).map(plan => {
													let value =
														plansYalo[plan].benefits.some(
															b => b === benefitId
														) == 1 ? (
															<FaCheck size={20} color={'#23A455'} />
														) : (
															''
														);

													return (
														<td className='tablecheck' key={plan}>
															{value}
														</td>
													);
												})}
											</tr>
										);
									})}

									<tr className={loja}>
										<th className='noneOnMobile'></th>
										{Object.keys(plansYalo).map(plan => {
											let buttonStyle = btnStyle[plan];
											let planType = titleStyle[plan];
											// let price = planPrice[plan].split(',');
											return (
												<th
													className={`table-${planType} bottom ${loja}`}
													key={plan}>
													<h2>
														<strong
															className={`product-table-plan-price ${colCount}`}>
															R$ {planPrice[plan]}
															<span className='price-span'>/mês</span>
														</strong>
													</h2>
													<Link
														to={`/loja/${loja}/beneficiario?assinatura=${planType}&code=11`}>
														<button
															className={`btn-orange1 ${colCount}`}
															style={buttonStyle}>
															ASSINAR AGORA
														</button>
													</Link>
												</th>
											);
										})}
									</tr>
								</tbody>
							</table>
							{loja === 'brasiladmindividual' ? (
								<h3 className='table-carencia'>
									Carência de 30 dias corridos, para uso dos benefícios.
								</h3>
							) : (
								''
							)}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
